import { Check, Plus } from "lucide-react";

import { convertUlToArray } from "../../../handlers/utilityFunctions";
import { cn } from "../../../lib/utils";

export interface EditorListItem {
	id: number | string;
	title: string;
	added: boolean;
}

interface EditorListItemsProps {
	editorListItems: EditorListItem[];
	editorContent: string;
	setEditorContent: (content: string) => void;
	setEditorListItems: (items: EditorListItem[]) => void;
	/** Overrides the default fixed height, for hosts that size to their content. */
	className?: string;
}

const EditorListItems = (props: EditorListItemsProps) => {
	const editorListHandler = (data: string) => {
		//remove the button text from the li text content
		const liContent = data;
		let newEditorContent = "";

		//check if the editor content has an existing list
		const hasUl = props.editorContent.indexOf("<ul>");

		//if it has an existing list already
		if (hasUl !== -1) {
			//if the clicked item is present in the list
			if (props.editorContent.indexOf(liContent) !== -1) {
				//remove the item from the editor&#39;s list
				newEditorContent = props.editorContent.replace(`<li>${liContent}</li>`, "");
			} else {
				//add the item to the editors list
				newEditorContent = props.editorContent
					.substring(0, props.editorContent.indexOf("</ul>"))
					.concat("<li>", liContent, "</li></ul>");
			}
		} else {
			//create a new list and add a li
			newEditorContent = props.editorContent.concat("<ul><li>", liContent, "</li></ul>");
		}

		props.setEditorContent(newEditorContent);
	};

	const arrayedContent = convertUlToArray(props.editorContent);

	const theList = props.editorListItems.map((editorListItem) => {
		const presentItem = arrayedContent.findIndex((listItem) => listItem.value === editorListItem.title.trim());
		if (presentItem !== -1) {
			editorListItem.added = true;
		} else {
			editorListItem.added = false;
		}

		return (
			<li
				onClick={() => editorListHandler(editorListItem.title)}
				key={editorListItem.id}
				id={String(editorListItem.id)}
				className="flex cursor-pointer items-center justify-between border-black/10 border-b py-2 text-xs last:border-b-0"
			>
				<span>{editorListItem.title}</span>
				<div className="ml-2">
					<button
						type="button"
						id={String(editorListItem.id)}
						tabIndex={-1}
						className={`flex w-[50px] shrink-0 items-center justify-center rounded-[5px] p-[5px] ${
							editorListItem.added ? "bg-[#03a9f4] text-white" : "bg-[#d6e7ff] text-gray-900"
						}`}
					>
						{editorListItem.added ? <Check className="size-3.5" /> : <Plus className="size-3.5" />}
					</button>
				</div>
			</li>
		);
	});
	return (
		<ul
			className={cn(
				"m-0 h-[336px] list-none overflow-y-auto rounded-md border border-[#d5dbe1] border-dashed bg-[#f8f8f8] px-4 py-2",
				props.className,
			)}
		>
			{theList}
		</ul>
	);
};

export default EditorListItems;
